// removed by extract-text-webpack-plugin
module.exports = {"trending":"Legal__trending--G3rxP","blueHeading":"Legal__blueHeading--1AAeg","boxWrapper":"Legal__boxWrapper--3pvZD","terms":"Legal__terms--2p42u","widgetBody":"Legal__widgetBody--CzrFW","bounce":"Legal__bounce--29YEB"};


//////////////////
// WEBPACK FOOTER
// ./src/legal/components/Legal/Legal.css
// module id = ./src/legal/components/Legal/Legal.css
// module chunks = 2